/** Tonalidad del swatch de icono. Aliases `warning`/`error`/`success` se normalizan en SCSS. */
export type MetricCardTone =
  | 'blue'
  | 'orange'
  | 'yellow'
  | 'red'
  | 'green'
  | 'warning'
  | 'error'
  | 'success'
  | 'neutral';

/** Distribución del grid de cards. */
export type MetricCardsLayout = 'auto-fit' | 'six' | 'three';

export interface MetricCardItem {
  id: string;
  /** Texto ya resuelto (prioridad sobre `labelKey`). */
  label?: string;
  /** Clave i18n cuando el feature no pre-traduce. */
  labelKey?: string;
  value: number | string;
  icon: string;
  tone: MetricCardTone;
  subValue?: string | null;
  /** Porcentaje opcional mostrado con flecha ascendente. */
  deltaPercent?: number | null;
  /** Texto ya resuelto del tooltip "cómo se calcula" (prioridad sobre `tooltipKey`). */
  tooltip?: string | null;
  /** Clave i18n del tooltip cuando el feature no pre-traduce. */
  tooltipKey?: string | null;
}

export const DEFAULT_METRIC_CARDS_LAYOUT: MetricCardsLayout = 'auto-fit';
export const DEFAULT_METRIC_CARDS_SELECTABLE = true;

export const METRIC_CARD_TONES: readonly MetricCardTone[] = [
  'blue',
  'orange',
  'yellow',
  'red',
  'green',
  'warning',
  'error',
  'success',
  'neutral',
] as const;

export const METRIC_CARDS_LAYOUTS: readonly MetricCardsLayout[] = [
  'auto-fit',
  'six',
  'three',
] as const;

/** Normaliza aliases de tono al modificador BEM canónico. */
export function resolveMetricCardTone(tone: MetricCardTone): string {
  switch (tone) {
    case 'warning':
      return 'yellow';
    case 'error':
      return 'red';
    case 'success':
      return 'green';
    default:
      return tone;
  }
}
